import * as Actions from '../../actions/fuse/index';
import {fuseNavigationConfig} from 'fuse-configs/fuseNavigationConfig';

let initialState = fuseNavigationConfig;

// if(localStorage.getItem('user') !== '' && localStorage.getItem('user') !== null){

//     switch (JSON.parse(localStorage.getItem('user')).peran_id) {
//         case 13: // pengawas
//             initialState[0].children[1].children.splice(1,2); // menghilangkan menu manajemen dan tukar pengguna
//             initialState[0].children.splice(4,1); // menghilangkan menu kirim data
//             break;
//         case 14: // komite
//             initialState[0].children[1].children.splice(1,2); // menghilangkan menu manajemen dan tukar pengguna
//             initialState[0].children.splice(4,1); // menghilangkan menu kirim data
//             break;
//         case 90: // Peserta Didik
//             initialState[0].children[1].children.splice(1,2); // menghilangkan menu manajemen dan tukar pengguna
//             initialState[0].children.splice(4,1); // menghilangkan menu kirim data
//             break;
//         case 12: // Peserta Didik
//             initialState[0].children[1].children.splice(1,2); // menghilangkan menu manajemen dan tukar pengguna
//             initialState[0].children.splice(4,1); // menghilangkan menu kirim data
//             break;
//         default:
//             // do nothing
//             break;
//     }
// }

// console.log(initialState[0]);

const navigation = function (state = initialState, action) {
    switch ( action.type )
    {
        case Actions.GET_NAVIGATION:
        {

            // if(localStorage.getItem('user') !== '' && localStorage.getItem('user') !== null){
            //     switch (JSON.parse(localStorage.getItem('user')).peran_id) {
            //         case 13: // pengawas
            //             state[0].children[1].children.splice(1,2); // menghilangkan menu manajemen dan tukar pengguna
            //             state[0].children.splice(4,1); // menghilangkan menu kirim data
            //             break;
            //         case 14: // komite
            //             state[0].children[1].children.splice(1,2); // menghilangkan menu manajemen dan tukar pengguna
            //             state[0].children.splice(4,1); // menghilangkan menu kirim data
            //             break;
            //         case 90: // Peserta Didik
            //             state[0].children[1].children.splice(1,2); // menghilangkan menu manajemen dan tukar pengguna
            //             state[0].children.splice(4,1); // menghilangkan menu kirim data
            //             break;
            //         case 12: // Peserta Didik
            //             state[0].children[1].children.splice(1,2); // menghilangkan menu manajemen dan tukar pengguna
            //             state[0].children.splice(4,1); // menghilangkan menu kirim data
            //             break;
            //         default:
            //             // do nothing
            //             break;
            //     }
            // }
            
            // console.log(state);

            return [
                ...state
            ];
        }
        case Actions.SET_NAVIGATION:
        {
            return [
                ...action.navigation
            ];
        }
        case Actions.RESET_NAVIGATION:
        {
            return [
                ...initialState
            ];
        }
        default:
        {
            return state;
        }
    }
};

export default navigation;


// WEBPACK FOOTER //
// ./src/store/reducers/fuse/navigation.reducer.js